// Configura la PWA "Tecnomyl Granos" sólo cuando se navega a /granos,
// sin afectar el portal de cartera en /.
export function enableGranosPWA() {
  const head = document.head;

  const ensure = (selector, create) => {
    let el = document.querySelector(selector);
    if (!el) {
      el = create();
      head.appendChild(el);
    }
    return el;
  };

  ensure('link[rel="manifest"]', () => {
    const l = document.createElement("link");
    l.rel = "manifest";
    l.href = "/granos-manifest.json";
    return l;
  });

  const theme = ensure('meta[name="theme-color"]', () => {
    const m = document.createElement("meta");
    m.name = "theme-color";
    return m;
  });
  theme.content = "#0f5233";

  ensure('link[rel="apple-touch-icon"]', () => {
    const l = document.createElement("link");
    l.rel = "apple-touch-icon";
    l.href = "/granos-icon-192.png";
    return l;
  });

  ensure('meta[name="apple-mobile-web-app-capable"]', () => {
    const m = document.createElement("meta");
    m.name = "apple-mobile-web-app-capable";
    m.content = "yes";
    return m;
  });
  ensure('meta[name="apple-mobile-web-app-status-bar-style"]', () => {
    const m = document.createElement("meta");
    m.name = "apple-mobile-web-app-status-bar-style";
    m.content = "black-translucent";
    return m;
  });
  ensure('meta[name="apple-mobile-web-app-title"]', () => {
    const m = document.createElement("meta");
    m.name = "apple-mobile-web-app-title";
    m.content = "Tecnomyl Granos";
    return m;
  });

  document.title = "Tecnomyl Granos";

  if ("serviceWorker" in navigator) {
    window.addEventListener("load", () => {
      navigator.serviceWorker.register("/granos-sw.js").catch(() => {});
    });
  }
}
